import React, { useState } from "react";
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";
import logo from "./Images/SECTORB12_hd.png";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const response = await fetch("https://sectorb12.info/api/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username: email, password: password }),
      });
      const data = await response.json();
      if (response.ok) {
        localStorage.setItem("token", data.token);
        localStorage.setItem("rol", data.rol);
        localStorage.setItem("id", data.id);
        navigate("/home");
      } else {
        setError(data.message || "Error en el inicio de sesión");
      }
    } catch (err) {
      setError("Ocurrió un error al conectarse con el servidor");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container
      fluid
      className="d-flex align-items-center justify-content-center"
      style={{ minHeight: "100vh", backgroundColor: "#f0f4f0" }}
    >
      <Row className="w-100 justify-content-center">
        <Col xs={11} sm={9} md={7} lg={5} xl={4}>
          <Card
            className="border-0"
            style={{
              borderRadius: "16px",
              boxShadow: "0 8px 32px rgba(0,0,0,0.10)",
              overflow: "hidden",
            }}
          >
            {/* Cabecera blanca: el fondo verde quedaba regular */}
            <div
              style={{
                backgroundColor: "#ffffff",
                borderBottom: "1px solid #e5e5e5",
                padding: "32px 24px 24px",
                textAlign: "center",
              }}
            >
              <img
                src={logo}
                alt="Logo Sector BXII"
                style={{
                  width: "80%",
                  maxWidth: 240,
                  height: "auto",
                }}
              />
              <p
                style={{
                  color: "#0f8d44",
                  marginTop: "16px",
                  marginBottom: 0,
                  fontSize: "13px",
                  letterSpacing: "0.05em",
                  textTransform: "uppercase",
                  fontWeight: 600,
                }}
              >
                  Oficina Virtual
              </p>
            </div>

            {/* Formulario */}
            <Card.Body className="p-4">
              {error && (
                <div
                  className="mb-3 p-2 text-center"
                  style={{
                    backgroundColor: "#fde8e8",
                    color: "#c0392b",
                    borderRadius: "6px",
                    fontSize: "13px",
                  }}
                >
                  {error}
                </div>
              )}

              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label style={{ fontWeight: 600, color: "#333", fontSize: "14px" }}>
                    Correo electrónico
                  </Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="correo@ejemplo.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    style={{
                      padding: "11px 14px",
                      borderRadius: "8px",
                      border: "1px solid #ddd",
                      fontSize: "14px",
                    }}
                  />
                </Form.Group>

                <Form.Group className="mb-4">
                  <Form.Label style={{ fontWeight: 600, color: "#333", fontSize: "14px" }}>
                    Contraseña
                  </Form.Label>
                  <Form.Control
                    type="password"
                    placeholder="••••••••"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    style={{
                      padding: "11px 14px",
                      borderRadius: "8px",
                      border: "1px solid #ddd",
                      fontSize: "14px",
                    }}
                  />
                </Form.Group>

                <Button
                  type="submit"
                  disabled={loading}
                  className="w-100"
                  style={{
                    padding: "12px",
                    backgroundColor: "#0f8d44",
                    border: "none",
                    borderRadius: "8px",
                    fontWeight: 600,
                    fontSize: "15px",
                    letterSpacing: "0.02em",
                  }}
                >
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" />
                      Cargando...
                    </>
                  ) : (
                    "Acceder"
                  )}
                </Button>
              </Form>

              <p className="text-center mt-4 mb-0" style={{ color: "#999", fontSize: "12px" }}>
                ¿Problemas para acceder? Contacte con el administrador.
              </p>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Login;